module.exports = __webpack_public_path__ + "img/7B.ac1adf04.png";